export class EffortType{
    id?:string;
    name!:string;
    description!:string;
}